import { render } from "./ForgotPassword.vue?vue&type=template&id=7f231e0e"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ForgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f231e0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f231e0e', __exports__)) {
    api.reload('7f231e0e', __exports__)
  }
  
  module.hot.accept("./ForgotPassword.vue?vue&type=template&id=7f231e0e", () => {
    api.rerender('7f231e0e', render)
  })

}


export default __exports__